<template>
  <div
    class="about"
    style="position: relative;"
  >
    <div
      style="width: 100%;height: 100%;"
      ref="chart"
    ></div>
    <MaskingLayer></MaskingLayer>
    <div
      class="celebrate"
      v-if="fireworkShow"
    >
      <VueFireworks v-model="fireworkShow"></VueFireworks>
    </div>
    <div
      v-if="fireworkShow"
      class="celebrate"
      style="background-color: transparent;"
    >
      <VueWordArt
        theme="radial"
        font-size="60px"
        class="animate__animated animate__rotateIn"
        style="margin-bottom: 195px; -webkit-animation: bounce 2s infinite;"
      >
        恭喜累计产量突破六百万双
      </VueWordArt>
    </div>
  </div>
</template>

<script>
import 'echarts-gl';
import MaskingLayer from './components/MaskingLayer-Ex.vue';
import VueFireworks from 'vue-fireworks';
import { VueWordArt } from 'vue-wordart';
import 'animate.css';

export default {
  name: 'ExhibitionView',
  components: {
    MaskingLayer,
    VueFireworks,
    VueWordArt
  },
  data () {
    return {
      ROOT_PATH: 'https://echarts.apache.org/examples',
      fireworkShow: false
    }
  },
  mounted () {
    console.log(this.$route.query)
    if (this.$route.query.earth !== '0') {
      this.initCharts();
    }
    const proNum = localStorage.getItem("zs-tek-bigdata");
    if (proNum > 6000000 && proNum < 6005000) {
      this.fireworkShow = true;
    }
  },
  methods: {
    initCharts () {
      let myChart = this.$echarts.init(this.$refs.chart);
      myChart.setOption({
        backgroundColor: 'rgba(0, 0, 0, 0)',
        globe: {
          baseTexture: require('@/assets/images/earth.jpg'),
          // heightTexture: require('@/assets/images/bathymetry_bw_composite_4k.jpg'),
          // displacementScale: 0.1,
          shading: 'lambert',
          // environment: require('@/assets/images/starfield.jpg'),
          light: {
            ambient: {
              intensity: 0.1
            },
            main: {
              intensity: 1.5
            }
          },
          layers: [
            {
              type: 'blend',
              blendTo: 'emission',
              texture: require('@/assets/images/night.jpg')
            },
            // {
            //   type: 'overlay',
            //   texture: require('@/assets/clouds.png'),
            //   shading: 'lambert',
            //   distance: 5
            // }
          ],
          globeRadius: 70,
          top: '10%',
          viewControl: {
            targetCoord: [116.46, 39.92]
          }
        },
        series: [
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 3,
            rippleEffect: {
              brushType: 'stroke'
            },
            label: {
              fontSize: 24,
              show: true,
              position: 'right',
              formatter: '{b}'
            },
            itemStyle: {
              normal: {
                color: '#f5f802'
              }
            },
            data: [
              { name: '瑞士', value: [-102.646409, 59.994255], symbolSize: 20 },
              { name: '加拿大', value: [-100.696295, 33.679979], symbolSize: 20 },
            ]
          }
        ]
      });
    },
  }
}
</script>

<style scoped>
.about {
  width: 100%;
  height: 100%;
}

.celebrate {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  background-color: rgba(0, 0, 0, 0.25);
  display: flex;
  justify-content: center;
  align-items: center;
}

@-webkit-keyframes bounce {

  /*创建动画*/
  0%,
  100%,
  20%,
  50%,
  80% {
    -webkit-transform: translateY(0);
  }

  40% {
    -webkit-transform: translateY(-30px);
  }

  60% {
    -webkit-transform: translateY(-15px);
  }
}
</style>
